export default __webpack_public_path__ + "static/media/Others_Glasses.447e56b8.svg";